<template>
  <div style="padding: 10px 10px 10px 0">
    <el-dialog :title="title" :visible.sync="show" width="750px">
      <el-form
        ref="formPost"
        :model="form"
        :rules="rules"
        label-width="100px"
        :inline="false"
      >
      <el-row :gutter="10"> <!-- gutter 可以设置列与列之间的间隔 -->
        <el-col :span="12">
        <el-form-item label="合同编号" prop="contractNumber">
          <el-input
            size="small"
            :disabled="title[0] == '查'"
            v-model="form.contractNumber"
            placeholder="请输入合同编号"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同类型" prop="contractType">
          <el-select
            size="small"
            :disabled="title[0] == '查'"
            clearable
            v-model="form.contractType"
            @change="handleSelectChange"
          >
            <el-option
              v-for="item in contractNumberList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同名称" prop="contractName">
          <el-input
            size="small"
            :disabled="title[0] == '查'"
            v-model="form.contractName"
            placeholder="请输入合同名称"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
          <!-- <el-form-item label="合同名称" prop="contractName" v-if="!showInputs">
            <el-input
              size="small"
              :disabled="title[0] == '查'"
              v-model="form.contractName"
              placeholder="请输入合同名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="广告位编号" prop="contractName" v-else>
            <el-input
              size="small"
              :disabled="title[0] == '查'"
              v-model="form.contractName"
              placeholder="请输入广告位编号"
            ></el-input>
          </el-form-item> -->

        <el-form-item label="合同金额" prop="contractAmount">
          <el-input
            size="small"
            :disabled="title[0] == '查'"
            v-model="form.contractAmount"
            placeholder="请输入合同金额"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="签约人" prop="appendixa">
          <el-input
            size="small"
            :disabled="title[0] == '查'"
            v-model="form.appendixa"
            placeholder="请输入签约人"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="签约单位" prop="nameContractingUnit">
          <el-input
            size="small"
            :disabled="title[0] == '查'"
            v-model="form.nameContractingUnit"
            placeholder="请输入签约单位"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="履行期限(月)" prop="contractPeriod">
          <el-input
           style="width: 100%"
            size="small"
            :disabled="title[0] == '查'"
            v-model="form.contractPeriod"
            placeholder="请输入合同期限"
          ></el-input>
        </el-form-item> 
      </el-col>
      <el-col :span="12">
        <el-form-item label="签订时间" prop="signingDate">
          <el-date-picker
            style="width: 100%"
            clearable
            :disabled="title[0] == '查'"
            size="small"
            v-model="form.signingDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择时间"
          >
          </el-date-picker>
        </el-form-item>       
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同开始时间" prop="endDate">
          <el-date-picker
            style="width: 100%"
            clearable
            :disabled="title[0] == '查'"
            size="small"
            v-model="form.appendixb"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同结束时间" prop="endDate">
          <el-date-picker
            style="width: 100%"
            clearable
            :disabled="title[0] == '查'"
            size="small"
            v-model="form.appendixc"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择时间"
          >
          </el-date-picker>
        </el-form-item>
        </el-col>
      </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="其他" prop="appendix" >
              <el-input
                maxlength="150"
                v-model="form.appendix"
                placeholder="请输入"
                type="textarea"
                rows="6"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <div v-if="showInputs">
          <el-form-item label="广告位置" prop="signingBasis">
            <el-input
              size="small"
              :disabled="title[0] == '查'"
              v-model="form.signingBasis"
              placeholder="请输入广告位置"
            ></el-input>
          </el-form-item>   
          <el-form-item label="广告类型" prop="biddingSituation">
            <el-input
              size="small"
              :disabled="title[0] == '查'"
              v-model="form.biddingSituation"
              placeholder="请输入广告类型"
            ></el-input>
          </el-form-item>     
          <el-form-item label="广告品牌" prop="performance">
            <el-input
              size="small"
              :disabled="title[0] == '查'"
              v-model="form.performance"
              placeholder="请输入广告品牌"
            ></el-input>
          </el-form-item>
          <el-form-item label="费用" prop="textSelection">
            <el-input
              size="small"
              :disabled="title[0] == '查'"
              v-model="form.textSelection"
              placeholder="请输入费用"
            ></el-input>
          </el-form-item>
          <el-form-item label="规格" prop="whetherFile">
            <el-input
              size="small"
              :disabled="title[0] == '查'"
              v-model="form.whetherFile"
              placeholder="请输入规格"
            ></el-input>
          </el-form-item>
          
        </div>        -->
        <!-- <el-form-item label="是否归档" prop="whetherFile">
          <el-select
            size="small"
            v-model="form.whetherFile"
            placeholder="请选择是否归档"
            :disabled="title[0] == '查'"
          >
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
          <el-input size="small" style="width:100%" :disabled="title[0] == '查'" v-model="form.whetherFile"
                            placeholder="请输入是否归档"></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="附件上传" v-if="title[0] != '查'">
          <el-upload
            ref="uploadFile"
            class="upload-demo"
            action="/api/admin/dutyInfo/uploadFile"
            name="file"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :headers="headers"
            :on-success="onSuccess"
            :on-remove="fileRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload> -->
          <!-- :show-file-list="false"
					<div v-for="(item, index) in fileList" :key="index"
						style="color: #3C98FF;cursor: pointer;display: flex;justify-content: space-between;">
						<div @click="down(item.name, item.url)">{{ item.name }}</div>
						<div @click="delUrl(index)"><i class="el-icon-delete"></i></div>
					</div> 
        </el-form-item>
        <el-form-item label="附件下载" v-if="title[0] == '查' && fileList.length != 0">
          <div
            @click="down(item.name, item.url)"
            v-for="item in fileList"
            style="color: #3c98ff; cursor: pointer"
          >
            {{ item.name }}
          </div>
        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false" size="small">取 消</el-button>
        <el-button v-if="title[0] != '查'" type="primary" size="small" @click="ok"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-form :inline="true" :model="selectForm" class="demo-form-inline">
      <div class="flex sb">
        <div>         
          <el-form-item label="合同编号">
            <el-input
              size="small"
              v-model="selectForm.contractNumber"
              placeholder="合同编号"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="合同名称">
            <el-input
              size="small"
              v-model="selectForm.contractName"
              placeholder="合同名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="签约人">
            <el-input
              size="small"
              v-model="selectForm.appendixa"
              placeholder="签约人"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="签订时间">
            <el-date-picker
              clearable
              size="small"
              v-model="queryDate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="query()">查询</el-button>
            <el-button size="small" type="primary" @click="addRow()">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="addTemplate"
              >下载导入模板</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-upload
              action="/api/admin/othercontract/addOtherContractsByExcel"
              name="excelFile"
              :show-file-list="false"
              :headers="headers"
              :on-success="success"
              :on-error="error"
            >
              <el-button size="small" type="primary">导入</el-button>
            </el-upload>
          </el-form-item>
          <!-- <el-button size="small" type="primary" @click="dc()">导出</el-button> -->
          <!-- </el-form-item> -->
        </div>
        <div></div>
      </div>
    </el-form>
    <el-table :data="data" style="width: 100%" border v-loading="loading">
      <el-table-column prop="id" label="序号"></el-table-column>
      <el-table-column prop="contractNumber" label="合同编号"></el-table-column>
      <el-table-column prop="contractType" label="合同类型"></el-table-column>
      <el-table-column prop="contractName" label="合同名称"></el-table-column>
      <el-table-column prop="contractAmount" label="合同金额"></el-table-column>
      <el-table-column prop="signingDate" label="签订时间">
        <template slot-scope="{ row }">{{
          row.signingDate ? row.signingDate.split("T")[0] : ""
        }}</template>
      </el-table-column>
      <el-table-column prop="nameContractingUnit" label="签约单位"></el-table-column>
      <el-table-column prop="appendixa" label="签约人"></el-table-column>      
      <el-table-column prop="contractPeriod" label="履行期限（月）"></el-table-column>
      <el-table-column prop="appendixb" label="合同开始时间">
        <template slot-scope="{ row }">{{
          row.appendixb ? row.appendixb.split("T")[0] : ""
        }}</template>
      </el-table-column>
      <el-table-column prop="appendixc" label="合同结束时间">
        <template slot-scope="{ row }">{{
          row.appendixc ? row.appendixc.split("T")[0] : ""
        }}</template>
      </el-table-column>
      <el-table-column prop="appendix" label="其他">
        <template slot-scope="scope">
          <div class="ellipsis-cell">{{ scope.row.appendix }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="appendix" label="其他" cclass="ellipsis-cell"></el-table-column> -->
      <!-- <el-table-column prop="appendixa" label="附件名称"></el-table-column>
            <el-table-column prop="appendixb" label="预留字段"></el-table-column>
            <el-table-column prop="appendixc" label="预留字段"></el-table-column> -->
      <el-table-column prop="date" label="操作" width="140">
        <template slot-scope="{ row }">
          <el-button type="text" @click="setRow(row, '1')">详情</el-button>
          <el-button type="text" @click="setRow(row, '2')">编辑</el-button>
          <el-button type="text" @click="movRow(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="count > 0"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="selectForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import publicExport from "../../assets/js/publicExport.js";
import downloadFile from "../../assets/js/downloadFile.js";
export default {
  data() {
    return {
      isGui: [
        {
          label: "是",
        },
        {
          label: "否",
        },
      ],
      showInputs: false,
      isAdd: true,
      loading: false,
      fileNameList: [],
      filePathList: [],
      typeList: [
        {
          label: "零售",
          value: "零售",
        },
        {
          label: "娱乐",
          value: "娱乐",
        },
        {
          label: "餐饮",
          value: "餐饮",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      headers: {
        Authorization: localStorage.access_token,
      },
      title: "新增",
      count: 0,
      show: false,
      queryDate: [],
      selectForm: {
        contractNumber: null, //合同编号
        contractName: null, //合同名字
        signingDate: null, //
        endDate: null, //
        currentPage: 1,
        pageSize: 10,
      },
      fileList: [],
      oldForm: "",
      contractNumberList: [
        {
          value: "仓库租赁",
          label: "仓库租赁",
        },
        {
          value: "广告牌租赁",
          label: "广告牌租赁",
        },
        {
          value: "车位租赁",
          label: "车位租赁",
        },
        {
          value: "其他合同",
          label: "其他合同",
        },
      ],
      form: {
        contractNumber: "",
        contractType: "",
        contractName: "",
        signingBasis: "",
        biddingSituation: "",
        textSelection: "",
        contractAmount: "",
        signingDate: "",
        appendixa: "", 
        appendix:"",      
        nameContractingUnit: "",
        contractPeriod: "",
        performance: "",
        endDate: "",
        whetherFile: "",
        numberContractCopies: "",
      },
      data: [],
      rules: {
        contractNumber: [{ required: true, message: "请输入" }],
        contractType: [{ required: true, message: "请选择"}],
      },
    };
  },
  methods: {
    success(res) {
      if (res.code == 0) {
        this.getAll();
        this.$message.success("导入成功");
      } else if (res.code == 500) {
        this.$message.error("导入失败，请使用模版导入！");
      } else {
        this.$message.error(res.message);
      }
    },
    error(res) {
      this.$message.success("导入失败");
    },
    handleSelectChange(value) {
      if(value=="广告牌租赁"){
        this.showInputs=true
      }else{
        this.showInputs=false
      }
    },
    down(name, url) {
      // let a = document.createElement('a')
      // a.href = url;
      // a.click();
      window.open(url);
    },
    delUrl(index) {
      this.fileNameList.splice(index, 1);
      this.filePathList.splice(index, 1);
      this.fileList.splice(index, 1);
    },
    addTemplate() {
      //下载导入模板
      this.$http
        .post(
          `/api/othercontract/downloadOtherContractTemplate`,
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=utf-8",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "其他合同导入模板.xls";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    movRow(obj) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .delete(`/api/othercontract/deleteOtherContractByID?id=${obj.id}`)
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success("删除成功");
                this.getAll();
              } else {
                this.$message.error("删除失败");
              }
            });
        })
        .catch(() => {});
    },
    beforeUpload(file, fileList) {
      let status = true;
      this.fileNameList.forEach((element) => {
        if (file.name.split(".")[0] == element) {
          status = false;
        }
      });
      if (!status) {
        this.$message.error(`${file.name.split(".")[0]}文件已存在！`);
      }
      return status;
    },
    onSuccess(response, file, fileList) {
      // this.detailFileList(fileList);
      if (response.code == "0") {
        // this.form.appendix = fileList[0].response.data.filePath;
        // this.form.appendixa = fileList[0].response.data.fileName;
        this.fileNameList.push(file.name.split(".")[0]);
        this.filePathList.push(response.data);
        this.fileList.push({
          name: file.name.split(".")[0],
          url: response.data,
          uid: file.uid,
        });
        // this.form.files = [res.data]
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");

        //上传失败不显示列表文件
        let uid = file.uid;
        this.clearShowList(uid);
        this.clearFileList(uid);
      }
    },
    // 删除临时文件
    fileRemove(file) {
      this.clearFileList(file.uid);
    },
    //下面两个方法是重点
    //清空文件列表
    clearFileList(uid) {
      let fileListIdx = this.fileList.findIndex((item) => item.uid === uid);
      this.fileList.splice(fileListIdx, 1);
      this.fileNameList.splice(fileListIdx, 1);
      this.filePathList.splice(fileListIdx, 1);
    },
    //清空显示列表
    clearShowList(uid) {
      let idx = this.$refs["uploadFile"].uploadFiles.findIndex(
        (item) => item.uid === uid
      );
      this.$refs.uploadFile.uploadFiles.splice(idx, 1);
    },
    setRow(obj, type) {
      if (type == 1) {
        this.title = "查看";
      } else {
        this.title = "编辑";
      }

      if(obj.contractType == "广告牌租赁"){
        this.showInputs=true
      }else{
        this.showInputs=false
      }
      // this.form = {
      //   ...obj,
      // };
      // debugger;
      // this.form.contractType = obj.contractType;
      let newFiles = [];
      this.fileNameList = [];
      this.filePathList = [];
      // console.log(this.form, obj, 'form');
      // if (this.form.appendixa) {
      //   let fileNameList = this.form.appendixa;
      //   let filePathList = this.form.appendix;
      //   this.fileNameList = fileNameList.split(",");
      //   this.filePathList = filePathList.split(",");
      //   this.fileNameList.forEach((element, index) => {
      //     newFiles.push({
      //       name: element,
      //       url: this.filePathList[index],
      //     });
      //   });
      // }
      this.fileList = newFiles;
      this.show = true;
      this.$nextTick(() => {
        this.form = JSON.parse(JSON.stringify(obj))
        this.$refs.formPost.resetFields();
      })
    },
    dc() {
      // publicExport("/api/othercontract/updateOtherContractByID", this.selectForm, "招商管理")
    },
    ok() {
      this.$refs.formPost.validate((valid) => {
        if (valid) {
            console.log();
          if (!this.isAdd) {
            return;
          }
          if (this.form.contractNumber == "") {
            this.$message.error(`请输入合同编号`);
            return;
          }
          let url = "/api/othercontract/addOtherContract";
          if (this.title == "编辑") {
            url = "/api/othercontract/updateOtherContractByID";
          }
          // var a = new Date().getTime()
          // this.form.createTime = a
          // if (this.fileList.length != 0) {
          //   this.form.appendixa = this.fileNameList.toString();
          //   this.form.appendix = this.filePathList.toString();
          // } else {
          //   this.form.appendixa = "";
          //   this.form.appendix = "";
          // }
          this.isAdd = false;

          this.$http.post(url, this.form).then((res) => {
            this.isAdd = true;
            if (res.data.code == 0) {
              this.getAll();
              this.show = false;
              this.$message.success(`${this.title}成功`);
            } else {
              this.$message.error(`${this.title}失败`);
            }
          });
        } else {
          this.$message.error(`请输入必填`);
          return false;
        }
      });
    },
    addRow() {
      this.form = JSON.parse(JSON.stringify(this.oldForm));
      this.title = "新增";
      this.fileList = [];
      this.fileNameList = [];
      this.filePathList = [];
      this.userList = [];
      this.show = true;
      this.$nextTick(() => {
        this.$refs.formPost.resetFields();
      })
    },
    query() {
      this.selectForm.pageSize = 10;
      this.selectForm.currentPage = 1;
      this.getAll();
    },
    getAll() {
      this.loading = true;
      if (this.queryDate && this.queryDate.length == 2) {
        this.selectForm.signingDate = this.queryDate[0];
        this.selectForm.endDate = this.queryDate[1];
      } else {
        this.selectForm.signingDate = null;
        this.selectForm.endDate = null;
      }
      this.$http
        .post("/api/othercontract/queryOtherContract", this.selectForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code == 0) {
            this.data = res.data.data.items;
            this.count = res.data.data.totalNum;
          } else {
            this.data = [];
            this.count = 0;
          }
        });
    },
    handleClick() {
      this.getAll();
    },
    handleCurrentChange(val) {
      this.selectForm.currentPage = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.selectForm.pageSize = val;
      this.getAll();
    },
  },
  created() {
    this.oldForm = JSON.parse(JSON.stringify(this.form));
    this.getAll();
  },
};
</script>

<style scoped="scoped">
/* 添加这个样式到您的组件的 <style> 部分或全局样式文件 */
.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%; /* 根据需要调整宽度 */
  display: block; /* 确保 div 表现为块级元素 */
}
</style>
